const constants = {
  add: 'BOARD_ENTRY_ADD',
  remove: 'BOARD_ENTRY_REMOVE',
  set: 'BOARD_ENTRIES_SET',
  update: 'BOARD_ENTRY_UPDATE',
};

const add = (boardEntry) => ({
  type: constants.add,
  payload: boardEntry,
});

const remove = (boardEntry) => ({
  type: constants.remove,
  payload: boardEntry,
});

const set = (boardEntries) => ({
  type: constants.set,
  payload: boardEntries,
});

const update = (boardEntry) => ({
  type: constants.update,
  payload: boardEntry,
});

const boardEntriesActions = {
  constants,
  add,
  remove,
  set,
  update,
};

export default boardEntriesActions;
